import EndpointsBase from "../EndpointsBase";

class CartEndpoints extends EndpointsBase {
  setCart(fullCartNumber: number, forceCart: boolean = false, lastInstructionID: number = -1) {
    return this._sendRequest({
      method: `cart/setcart/`,
      headers: this._getAuthHeader(),
      data: { fullCartNumber, forceCart, lastInstructionID },
      run: this.server.postData,
    });
  }

  getSingleCart() {
    return this._sendRequest({
      method: "cart/GetSingleCart",
      data: {},
      headers: this._getAuthHeader(),
      run: this.server.postData,
    });
  }

  parkCart(cartId: number, parkPosition: string, parkLocation: number) {
    return this._sendRequest({
      method: "cart/parkCart",
      headers: this._getAuthHeader(),
      run: this.server.postData,
      data: {
        cartId,
        parkPosition,
        parkLocation,
      },
    });
  }
}

export default new CartEndpoints();
